<div class="ka-lap">
  <ion-card>
    <ion-card-header>
      <ion-card-title>KRÉTA-átvitel állapota</ion-card-title>
      <ion-card-subtitle>
        A SULINFORM a KRÉTA melletti kiegészítő rendszer (Nkt. 57. § (6)): a kötelező adatok helye a KRÉTA.
        Itt látszik adatkörönként, mi kerül át magától, mi marad kézi, és mi akadt el.
      </ion-card-subtitle>
    </ion-card-header>

    <ion-card-content>
      <div class="ka-fej">
        <ion-select label="Időszak" label-placement="stacked" interface="popover" [(ngModel)]="napok" (ionChange)="betolt()">
          <ion-select-option *ngFor="let n of napValasztek" [value]="n">utolsó {{ n }} nap</ion-select-option>
        </ion-select>
        <ion-button size="small" fill="outline" (click)="betolt()" [disabled]="toltodik">
          <ion-icon slot="start" name="refresh-outline"></ion-icon>Frissítés
        </ion-button>
      </div>

      <div *ngIf="toltodik"><ion-spinner name="dots"></ion-spinner> Betöltés…</div>
      <ion-note color="danger" *ngIf="hiba">{{ hiba }}</ion-note>

      <ng-container *ngIf="adat && !hiba">
        <div class="ka-osszkep">
          <div>
            <b>Ütemezett szinkron:</b>
            <ion-badge [color]="adat.utemezo.bekapcsolva ? 'success' : 'medium'">{{ adat.utemezo.bekapcsolva ? 'bekapcsolva' : 'kikapcsolva' }}</ion-badge>
            <span class="halvany" *ngIf="adat.utemezo.utolso_futas"> · utoljára: {{ ido(adat.utemezo.utolso_futas) }}
              <span *ngIf="adat.utemezo.utolso_eredmeny">({{ adat.utemezo.utolso_eredmeny }})</span></span>
          </div>
          <div>
            <b>KRÉTA-fiókok:</b> {{ adat.fiokok.hasznalhato }} használható / {{ adat.fiokok.aktiv }} aktív
            <span class="ka-hiba-szoveg" *ngIf="adat.fiokok.hibas_ellenorzes"> · {{ adat.fiokok.hibas_ellenorzes }} fiók legutóbbi ellenőrzése sikertelen</span>
            · <a routerLink="/admin/kreta-naploz">KRÉTA naplózás</a>
          </div>
        </div>

        <table class="ka-tabla">
          <thead>
            <tr>
              <th>Adatkör</th>
              <th>Átvitel</th>
              <th class="ka-szam">Átment</th>
              <th class="ka-szam">Kihagyva / vár</th>
              <th class="ka-szam">Hiba</th>
            </tr>
          </thead>
          <tbody>
            <ng-container *ngFor="let a of adat.adatkorok">
              <tr [class]="'ka-sor ka-' + szin(a)">
                <td>
                  <b>{{ a.cim }}</b>
                  <div class="halvany">{{ a.leiras }}</div>
                </td>
                <td>
                  <ion-badge [color]="a.mod === 'automatikus' ? 'success' : (a.mod === 'kezi' ? 'warning' : 'medium')">{{ modNev[a.mod] || a.mod }}</ion-badge>
                  <div class="halvany">{{ a.feltetel }}</div>
                  <div *ngIf="a.admin_ut" class="halvany"><a [routerLink]="a.admin_ut">beállítás →</a></div>
                </td>
                <ng-container *ngIf="a.kulcs !== 'zarojegy'; else zaroSor">
                  <td class="ka-szam">{{ a.atment }}</td>
                  <td class="ka-szam">
                    {{ a.kihagyva || 0 }}
                    <div class="halvany" *ngIf="a.varakozik">+ {{ a.varakozik }} vár átvitelre</div>
                    <div class="halvany" *ngIf="a.parositasra_var">+ {{ a.parositasra_var }} elküldve, párosításra vár</div>
                  </td>
                  <td class="ka-szam" [class.ka-hiba-szoveg]="a.hiba > 0">{{ a.hiba || 0 }}</td>
                </ng-container>
                <ng-template #zaroSor>
                  <td colspan="3" class="ka-zaro">
                    <b>Ezt a KRÉTÁ-ban kell rögzíteni.</b>
                    Az időszakban a SULINFORM-ban rögzítve: {{ a.felevi }} félévi és {{ a.ev_vegi }} év végi jegy.
                  </td>
                </ng-template>
              </tr>
              <tr *ngIf="a.okok?.length" class="ka-okok">
                <td colspan="5">
                  <span class="ka-ok-cim">Okok:</span>
                  <span *ngFor="let o of a.okok" class="ka-ok">
                    <ion-badge [color]="o.allapot === 'hiba' ? 'danger' : 'warning'">{{ o.db }}</ion-badge> {{ o.ok }}
                  </span>
                </td>
              </tr>
            </ng-container>
          </tbody>
        </table>
        <ion-note color="medium" class="ka-megj">
          Az óra + téma sorai KRÉTA-óránként a legutóbbi állapotot számolják (a később átment óra már nem kihagyott).
          A „kihagyva” nem feltétlenül hiba: pl. a KRÉTA-órához nincs SULINFORM-téma, mert a tanár még nem könyvelte.
        </ion-note>
      </ng-container>
    </ion-card-content>
  </ion-card>

  <ion-card>
    <ion-card-header>
      <ion-card-title>KRÉTA önteszt</ion-card-title>
      <ion-card-subtitle>
        Az ütemezett feladatok futásai és a funkciónkénti, csak olvasó önteszt (belépés, naplózás, helyettesítés, jegy,
        mulasztás, igazolás, feljegyzés, órarend, csoporttagság, tanulói adat, új tanuló) külön lapra került.
      </ion-card-subtitle>
    </ion-card-header>
    <ion-card-content>
      <ion-button size="small" routerLink="/admin/kreta-onteszt">
        <ion-icon slot="start" name="pulse-outline"></ion-icon>KRÉTA önteszt megnyitása
      </ion-button>
    </ion-card-content>
  </ion-card>
</div>
